import ApiAuthorzationRoutes from './components/ApiAuthorization/ApiAuthorizationRoutes';
import HomeTwo from './pages/HomeTwo'
// import Service from './pages/Service'
// import ServiceDetails from "./pages/ServiceDetails";
import BlogGridRightSidebar from './pages/BlogGridRightSidebar';
import Product from './pages/Product';
// import BlogGridWithoutSidebar from './pages/BlogGridWithoutSidebar';
// import BlogListLeftSidebar from './pages/BlogListLeftSidebar';
//  import BlogListRightSidebar from './pages/BlogListRightSidebar';
// import BlogDetailsPage from "./pages/BlogDetails";
// import Team from "./pages/Team";
// import TeamDetails from "./pages/TeamDetails";
import ProductsDetails from "./pages/ProductsDetails";
import About from "./pages/About";
import ContactUS from './templates/ContactUS/index';
import BoardofDirectors from './templates/BoardofDirectors';
import AppointmentCommittee from './templates/AppointmentCommittee';
import AuditCommittee from './templates/AuditCommittee';
import RiskCommittee from './templates/RiskCommittee';
import News from './templates/News/index';
import AnnouncementDetail from './templates/Announcement/index';
import Beneficiary from './templates/Beneficiary/index';
import Certificates from './templates/Certificates/index';
import Careers from './templates/Careers/index';
import Blogs from './templates/Blogs';
import BlogsDetail from './templates/Blogs/BlogDetail';
import Colleagues from './templates/Colleagues/index';
import Services from './templates/Services/index';
import SearchPage from './templates/SearchPage/index';
import NewsDetail from './templates/NewsDetail';
import CustomersService from './templates/CustomersService';

const AppRoutes = [
  {
    index: true,
    element: <HomeTwo />
  },
  // {
  //   path: `${process.env.PUBLIC_URL + '/services'}`,
  //   element: <Service />
  // },
  // {
  //   path: `${process.env.PUBLIC_URL + '/service/:serviceID'}`,
  //   element: <ServiceDetails />
  // },
  // {
  //   path: `${process.env.PUBLIC_URL + "/blog-grid-right-sidebar"}`,
  //   element: <BlogGridRightSidebar />
  // },
  {
    path: `${process.env.PUBLIC_URL + "/news/:id"}`,
    element: <NewsDetail />
  },
  {
    path: `${process.env.PUBLIC_URL + "/products/:page/:searchText/:categories"}`,
    element: <Product />
  },
  {
    path: `${process.env.PUBLIC_URL + "/products/:page/:searchText"}`,
    element: <Product />
  },
  {
    path: `${process.env.PUBLIC_URL + "/products/:page"}`,
    element: <Product />
  },
  {
    path: `${process.env.PUBLIC_URL + "/contactus"}`,
    element: <ContactUS />
  },

   {
    path: `${process.env.PUBLIC_URL + "/boardofDirectors"}`,
    element: <BoardofDirectors />
  },
  {
    path: `${process.env.PUBLIC_URL + "/appointmentCommittee"}`,
    element: <AppointmentCommittee />
  },
 {
    path: `${process.env.PUBLIC_URL + "/auditCommittee"}`,
    element: <AuditCommittee />
  },
   {
    path: `${process.env.PUBLIC_URL + "/riskCommittee"}`,
    element: <RiskCommittee />
  },
  {
    path: `${process.env.PUBLIC_URL + "/news"}`,
    element: <News />
  },
  {
    path: `${process.env.PUBLIC_URL + "/certificates"}`,
    element: <Certificates />
  },
  // {
  //   path: `${process.env.PUBLIC_URL + "/careers"}`,
  //   element: <Careers />
  // },
  {
    path: `${process.env.PUBLIC_URL + "/blogs/:page/:searchText"}`,
    element: <BlogGridRightSidebar />
  },
  {
    path: `${process.env.PUBLIC_URL + "/blogs/:page"}`,
    element: <BlogGridRightSidebar />
  },
  {
    path: `${process.env.PUBLIC_URL + "/colleagues-fa"}`,
    element: <Colleagues />
  },
  {
    path: `${process.env.PUBLIC_URL + "/searchedItemPage"}`,
    element: <SearchPage />
  },

  // {
  //   path: `${process.env.PUBLIC_URL + "/blog-grid-without-sidebar"}`,
  //   element: <BlogGridWithoutSidebar />
  // },
  // {
  //   path: `${process.env.PUBLIC_URL + "/blog-list-left-sidebar"}`,
  //   element: <BlogListLeftSidebar />
  // },
  // {
  //   path: `${process.env.PUBLIC_URL + "/blog-list-right-sidebar"}`,
  //   element: <BlogListRightSidebar />
  // },
  // {
  //   path: `${process.env.PUBLIC_URL + "/blog/:blogID"}`,
  //   element: <BlogDetailsPage />
  // },
  // {
  //   path: `${process.env.PUBLIC_URL + "/team"}`,
  //   element: <Team />
  // },
  // {
  //   path: `${process.env.PUBLIC_URL + "/team-member/:teamID"}`,
  //   element: <TeamDetails />
  // },
  {
    path: `${process.env.PUBLIC_URL + "/product/:acr/:id"}`,
    element: <ProductsDetails />
  },
  {
    path: `${process.env.PUBLIC_URL + "/about/:acr/:id"}`,
    element: <About />
  },
  {
    path: `${process.env.PUBLIC_URL + "/announcement/:id"}`,
    element: <AnnouncementDetail />
  },
  {
    path: `${process.env.PUBLIC_URL + "/beneficiary/:id"}`,
    element: <Beneficiary />
  },
  {
    path: `${process.env.PUBLIC_URL + "/blog/:acr/:id"}`,
    element: <BlogsDetail />
  },
  {
    path: `${process.env.PUBLIC_URL + "/customersservice/:id"}`,
    element: <CustomersService />
  },
  {
    path: `${process.env.PUBLIC_URL + "/services/:id"}`,
    element: <Services />
  },
  // {
  //   path: `${process.env.PUBLIC_URL + "/contact"}`,
  //   element: <Contact />
  // },
//   {
//     path: '/fetch-data',
//     requireAuth: true,
//     element: <FetchData />
//   },
  ...ApiAuthorzationRoutes
];

export default AppRoutes;